<template>
  <div id="real-data">
    <div class="device-title">
      {{$t("deviceCount")}}
    </div>
    <div class="device-data">
      <div class="deviceData-content">
        <dv-border-box-13>
          <div class="deviceContent-total">
            <div class="deviceTotal-name">{{$t("totalDevice")}}</div>
            <div class="deviceTotal-num">{{totalDevice}}</div>
          </div>
          <dv-decoration-2 style="width:80%;height:1%; margin-left: 10%;" />
          <div class="deviceContent-online">
            <div class="deviceOnline-name">{{$t("onDevice")}}</div>
            <div class="deviceOnline-num">{{onLineDevice}}</div>
          </div>
          <dv-decoration-2 style="width:80%;height:1%; margin-left: 10%;" />
          <div class="deviceContent-offline">
            <div class="deviceOffline-name">{{$t("offDevice")}}</div>
            <div class="deviceOffline-num">{{offLineDevice}}</div>
          </div>
        </dv-border-box-13>
      </div>
    </div>

    <div class="realData-title">
      {{$t("realTime")}}
    </div>
    <div class="realData-minute">
      <dv-border-box-10>
        <div class="realData-minute-title">
          {{$t("minuteRainfall")}}
        </div>
        <div class="relData-minute-content">
          <div class="relData-minuteContent-name">&ensp;{{$t("instantRainfall")}}</div>
          <div  class="relData-minuteContent-number">{{currentRainfall}}mm</div>
        </div>
        <dv-decoration-4 :reverse="true" class="dv4-minute"/>
        <div class="relData-minute-content">
          <div class="relData-minuteContent-name">{{$t("oneMinute")}}</div>
          <div  class="relData-minuteContent-number">{{currentRainfall}}mm</div>
        </div>
        <dv-decoration-4 :reverse="true" class="dv4-minute"/>
        <div class="relData-minute-content">
          <div class="relData-minuteContent-name">{{$t("fiveMinute")}}</div>
          <div class="relData-minuteContent-number">{{fiveRainfall}}mm</div>
        </div>
        <dv-decoration-4 :reverse="true" class="dv4-minute" />
        <div class="relData-minute-content">
          <div class="relData-minuteContent-name">{{$t("tenMinute")}}</div>
          <div class="relData-minuteContent-number">{{tenRainfall}}mm</div>
        </div>
      </dv-border-box-10>
    </div>

    <div class="realData-hour">
      <dv-border-box-10>
        <div class="realData-hour-title">
          {{$t("hourRainfall")}}
        </div>
        <div class="relData-hour-content">
          <div class="relData-hourContent-name">{{$t("currentPeriod")}}</div>
          <div class="relData-hourContent-number">{{currentHourRainfall}}mm</div>
        </div>
        <dv-decoration-4 :reverse="true" class="dv4-hour"/>
        <div class="relData-hour-content">
          <div class="relData-hourContent-name ">{{$t("previousPeriod")}}</div>
          <div class="relData-hourContent-number">{{lastHourRainfall}}mm</div>
        </div>
      </dv-border-box-10>
    </div>

  </div>
</template>

<script>
  import moment from "moment";
  import {getTimeDeviceHistory, getConnectTime} from "../untils/api/home";
  export default {
    name: 'RealData',
    props: ["lineInfo"],
    data() {
      return {
        currentRainfall: '-',
        fiveRainfall: '-',
        tenRainfall: '-',
        currentHourRainfall: '-',
        lastHourRainfall: '-',
        deviceInfo: {},
        key: '',
        totalDevice: 0,
        onLineDevice: 0,
        offLineDevice: 0,
        minuteTime:null,
        hourTime: null,
        rainFlg: false,
      }
    },

    watch: {
      lineInfo() {
        this.offLineDevice = this.lineInfo;
        this.onLineDevice = this.totalDevice - this.offLineDevice;
      }
    },

    beforeDestroy() {
      clearInterval(this.minuteTime);
      this.minuteTime = null;
      clearInterval(this.hourTime);
      this.hourTime = null;
    },

    methods: {
      /**
       * 初始化清空变量
       */
      iniRealData(deviceInfo, key) {
        this.deviceInfo = deviceInfo;
        this.key = key;
        this.currentRainfall = '-';
        this.fiveRainfall = '-';
        this.tenRainfall = '-';
        this.currentHourRainfall = '-';
        this.lastHourRainfall = '-';
        this.rainFlg = false;
        if(this.minuteTime !== null){
          clearInterval(this.minuteTime);
          this.minuteTime = null;
        }
        if(this.hourTime !== null){
          clearInterval(this.hourTime);
          this.hourTime = null;
        }
      },

      /**
       * 每隔一分钟获取1小时内历史遥测雨量数据
       */
      getHistoryInfo(){
        this.lastConnectTime();
        this.minuteTime = window.setInterval(() => {
          setTimeout(() => {
            this.lastConnectTime();
          }, 0)
        }, 1000 * 60);
      },

      /**
       * 获取最后一次更新时间，判断是否掉线
       */
      lastConnectTime() {
        getConnectTime(this.deviceInfo.entityType, this.deviceInfo.id).then(response => {
          let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
          if(response[0].value > beforeTime){//在线
            this.getMinuteHistory();
            this.rainFlg = false;
          } else if(!this.rainFlg) {//离线
            this.currentRainfall = "-";
            this.fiveRainfall = "-";
            this.tenRainfall = "-";
            this.currentHourRainfall = "-";
            this.rainFlg = true;
            this.$message({
              showClose: true,
              type: "warning",
              message: this.$t('deviceDisconnect')
            });
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取1小时内历史遥测雨量数据
       */
      getMinuteHistory(){
        let startTime = new Date(moment().subtract(1, "hours")).getTime();
        let endTime = new Date(moment()).getTime();
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, 0, 'NONE').then(response => {
          let index = '';
          for(let obj in response) {
            for(let i = 0; i < response[obj].length - 1; i++){
              if(parseFloat(response[obj][i].value) < parseFloat(response[obj][i + 1].value)){
                index = i;
                break;
              }
            }
          }
          if(JSON.stringify(response) === "{}"){
            this.currentRainfall = "-";
            this.fiveRainfall = "-";
            this.tenRainfall = "-";
            this.currentHourRainfall = "-";
            return;
          } else {
            this.deviceHistoryInfo(response, index);
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 设置当前雨量，五分钟内雨量， 十分钟内雨量 当前一小时雨量以及强一小时雨量
       * @param response
       */
      deviceHistoryInfo(response, index) {
        let currentHour = new Date(moment().format('YYYY-MM-DD HH:00:00')).getTime(); //当前整点时间
        for(let obj in response){
          //一分钟雨量
          // this.currentRainfall = response[obj].length >= 2 ? (parseFloat(response[obj][0].value) - parseFloat(response[obj][1].value)).toFixed(2) : 0.00;
          if(response[obj].length >= 2){
            this.currentRainfall =  parseFloat(response[obj][0].value) - parseFloat(response[obj][1].value) < 0
              ? parseFloat(response[obj][0].value).toFixed(2)
              : (parseFloat(response[obj][0].value) - parseFloat(response[obj][1].value)).toFixed(2);
          } else {
            this.currentRainfall = parseFloat(response[obj][0].value).toFixed(2)
          }

          //五分钟雨量
          // this.fiveRainfall = response[obj].length >= 5 ? (parseFloat(response[obj][0].value) - parseFloat(response[obj][4].value)).toFixed(2) : 0.00;
          if(response[obj].length >= 6) {
            if(index >= 5 || index === ''){
              this.fiveRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][5].value)).toFixed(2);
            }else {
              this.fiveRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][5].value))).toFixed(2);
            }
          } else {
            if(response[obj].length === 1){
              this.fiveRainfall = parseFloat(response[obj][0].value).toFixed(2);
            } else {
              if(index >= response[obj].length - 1 || index === ''){
                this.fiveRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
              } else {
                this.fiveRainfall =  (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
              }
            }
          }

          //十分钟雨量
          // this.tenRainfall = response[obj].length >= 10 ? (parseFloat(response[obj][0].value) - parseFloat(response[obj][9].value)).toFixed(2) : 0.00;
          if(response[obj].length >= 11){
            if(index >= 10 || index === ''){
              this.tenRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][10].value)).toFixed(2);
            }else {
              this.tenRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][10].value))).toFixed(2);
            }
          } else {
            if(response[obj].length === 1){
              this.tenRainfall = parseFloat(response[obj][0].value).toFixed(2);
            } else {
              if(index >= response[obj].length - 1 || index === ''){
                this.tenRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length -1].value)).toFixed(2);
              } else {
                this.tenRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
              }
            }
          }

          let flg = false;
          //当前一小时雨量
          for (let i = 0; i < response[obj].length; i++) {
            if(response[obj][i].ts === currentHour){
              // this.currentHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][i].value)).toFixed(2);
              if(i <= index || index === ''){
                this.currentHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][i].value)).toFixed(2);
              }else {
                this.currentHourRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][i].value))).toFixed(2);
              }
              flg = true;
              break;
            } else if(response[obj][i].ts < currentHour){
              // this.currentHourRainfall = i !== 0 ? (parseFloat(response[obj][0].value) - parseFloat(response[obj][i - 1].value)).toFixed(2) : 0;
              if(i !== 0) {
                if(i <= index || index === ''){
                  this.currentHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][i - 1].value)).toFixed(2);
                }else {
                  this.currentHourRainfall = (parseFloat(response[obj][0].value) +  (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][i - 1].value))).toFixed(2);
                }
              } else {
                this.currentHourRainfall = parseFloat(response[obj][0].value).toFixed(2);
              }
              flg = true;
              break;
            }
          }
          // if(!flg) this.currentHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
          if(!flg) {
            if(response[obj].length - 1 <= index || index === ''){
              this.currentHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
            }else {
              this.currentHourRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2);
            }
          }
        }
      },

      /**
       * 获取前一小时雨量
       */
      getLastHour(){
        this.LastHourInfo();
        this.hourTime = window.setInterval(() => {
          setTimeout(() => {
            this.LastHourInfo();
          }, 0)
        }, 1000 * 60 * 60);
      },

      /**
       * 每隔一小时获取一次前一小时雨量
       */
      LastHourInfo(){
        let startTime = new Date(moment().startOf('hour').subtract(1,'hours')).getTime(); // 前一个小时的整点时间
        let endTime = new Date(moment().startOf('hour')).getTime();//当前整点时间
        getTimeDeviceHistory(this.deviceInfo.entityType, this.deviceInfo.id, this.key, startTime, endTime, 0, 'NONE').then(response => {
          if(JSON.stringify(response) === "{}") {
            this.lastHourRainfall = "-";
            return;
          }
          let index = '';
          for(let obj in response){
            // this.lastHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
            for(let i = 0; i < response[obj].length - 1; i++){
              if(parseFloat(response[obj][i].value) < parseFloat(response[obj][i + 1].value)){
                index = i;
                break;
              }
            }
            if(index === ''){
              this.lastHourRainfall = (parseFloat(response[obj][0].value) - parseFloat(response[obj][response[obj].length - 1].value)).toFixed(2);
            } else {
              this.lastHourRainfall = (parseFloat(response[obj][0].value) + (parseFloat(response[obj][index + 1].value) - parseFloat(response[obj][response[obj].length - 1].value))).toFixed(2)
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取设备是否在线
       * @param deviceBoards
       */
      getDeviceLine(deviceBoards){
        this.totalDevice = deviceBoards.length;
        if (this.offLineDevice === 0) {
          this.onLineDevice = this.totalDevice - this.offLineDevice;
        }
      }
    }
  }
</script>
<style lang="less">
  @import "less/RealData.less";
</style>



// WEBPACK FOOTER //
// src/components/RealData.vue